/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PGATourModelUpdateInputsInput = {|
  modelId: string,
  fairwayGrassTypeIds?: ?$ReadOnlyArray<?string>,
  roughGrassTypeIds?: ?$ReadOnlyArray<?string>,
  greenGrassTypeIds?: ?$ReadOnlyArray<?string>,
  numRounds?: ?number,
  minRounds?: ?number,
  fromDate?: ?any,
  toDate?: ?any,
  courseIds?: ?$ReadOnlyArray<?string>,
  coursePars?: ?$ReadOnlyArray<?number>,
  minYards?: ?number,
  maxYards?: ?number,
  clientMutationId?: ?string,
|};
export type PGAModelBuilderPageUpdateInputsMutationVariables = {|
  input: PGATourModelUpdateInputsInput
|};
export type PGAModelBuilderPageUpdateInputsMutationResponse = {|
  +pgaTourModelUpdateInputs: ?{|
    +success: ?boolean
  |}
|};
export type PGAModelBuilderPageUpdateInputsMutation = {|
  variables: PGAModelBuilderPageUpdateInputsMutationVariables,
  response: PGAModelBuilderPageUpdateInputsMutationResponse,
|};
*/


/*
mutation PGAModelBuilderPageUpdateInputsMutation(
  $input: PGATourModelUpdateInputsInput!
) {
  pgaTourModelUpdateInputs(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PGATourModelUpdateInputsPayload",
    "kind": "LinkedField",
    "name": "pgaTourModelUpdateInputs",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PGAModelBuilderPageUpdateInputsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PGAModelBuilderPageUpdateInputsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5c96110b620f7501be3c018dd48fe498",
    "id": null,
    "metadata": {},
    "name": "PGAModelBuilderPageUpdateInputsMutation",
    "operationKind": "mutation",
    "text": "mutation PGAModelBuilderPageUpdateInputsMutation(\n  $input: PGATourModelUpdateInputsInput!\n) {\n  pgaTourModelUpdateInputs(input: $input) {\n    success\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '69cd00e9c7c3e2936063d5d69967a0bd';

module.exports = node;
